import React from 'react'
import Photos from '../header/photos/Photos'



function Posts() {
  return (
    <div className='posts '>
        <Photos/>
        <Photos/>
        </div>
  )
}


export default Posts